import React from "react";
import TRUCK_TYPES from "../assets/truck_types.js";

export default function ProfileDetails({
  profile,
  handleProfileChange,
  setIsHelpModalOpen,
  setIsCHRobinsonHelpModalOpen,
}) {
  return (
    <div className="form-grid">
      <div className="form-group">
        <label>Company Name</label>
        <input
          type="text"
          name="company_name"
          value={profile.company_name ?? ""}
          onChange={handleProfileChange}
          className="form-input"
          placeholder="Enter company name"
        />
      </div>
      <div className="form-group">
        <label>
          Phone Number
          <span style={{ color: "var(--danger)", marginLeft: "5px" }}>*</span>
        </label>
        <input
          type="tel"
          name="phone_number"
          value={profile.phone_number ?? ""}
          onChange={handleProfileChange}
          className="form-input"
          placeholder="Enter phone number"
          required
          minLength={10}
          maxLength={10}
          pattern="\d{9,}"
        />
      </div>

      {
        <>
          <div className="form-group">
            <label>MC Number</label>
            <input
              type="text"
              name="mc_number"
              value={profile.mc_number ?? ""}
              onChange={handleProfileChange}
              className="form-input"
              placeholder="Enter MC number"
            />
          </div>
          <div className="form-group">
            <label>
              DOT Number
              <span style={{ color: "var(--danger)", marginLeft: "5px" }}>
                *
              </span>
            </label>
            <input
              type="text"
              name="dot_number"
              value={profile.dot_number ?? ""}
              onChange={handleProfileChange}
              className="form-input"
              placeholder="Enter DOT number"
              required
            />
          </div>
        </>
      }
      {
        <>
          <div className="form-group">
            <label>Truck Type</label>
            <select
              name="truck_type"
              value={profile.truck_type ?? "V"}
              onChange={handleProfileChange}
              className="form-input"
            >
              {TRUCK_TYPES.map((type) => (
                <option key={type.value} value={type.value}>
                  {type.label}
                </option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <label>Origin City</label>
            <input
              type="text"
              name="origin_city"
              value={profile.origin_city ?? ""}
              onChange={handleProfileChange}
              className="form-input"
              placeholder="Enter origin city"
            />
          </div>
        </>
      }
      {
        <div className="form-group full-width">
          <label>
            Truckstop Integration ID
            <span
              style={{
                fontSize: "0.8rem",
                color: "var(--text-muted)",
                display: "block",
                marginTop: "2px",
              }}
            >
              Provide your Truckstop integration ID to find loads from Truckstop
            </span>
          </label>
          <input
            type="text"
            name="truckstop_integration_id"
            value={
              profile.truckstop_integration_id === "843982"
                ? "********"
                : profile.truckstop_integration_id ?? ""
            }
            onChange={handleProfileChange}
            className="form-input"
            placeholder="Enter your Truckstop integration ID"
            disabled={profile.truckstop_integration_id === "843982"}
          />
          <div
            style={{
              fontSize: "0.8rem",
              color: "var(--text-muted)",
              marginTop: "4px",
              display: "flex",
              alignItems: "center",
              gap: "4px",
              marginLeft: "10px",
              fontWeight: "500",
            }}
          >
            Need help getting a Truckstop ID?
            <button
              type="button"
              onClick={() => setIsHelpModalOpen(true)}
              style={{
                background: "none",
                border: "none",
                color: "var(--primary)",
                textDecoration: "underline",
                cursor: "pointer",
                padding: "0",
                font: "inherit",
                fontSize: "0.8rem",
                transition: "none",
                boxShadow: "none",
              }}
            >
              [Learn how]
            </button>
          </div>
        </div>
      }
      {
        <div className="form-group full-width">
          <label>
            C.H. Robinson T-Number
            <span
              style={{
                fontSize: "0.8rem",
                color: "var(--text-muted)",
                display: "block",
                marginTop: "2px",
              }}
            >
              Required for booking loads with C.H. Robinson
            </span>
          </label>
          <input
            type="text"
            name="ch_t_number"
            value={profile.ch_t_number ?? ""}
            onChange={handleProfileChange}
            className="form-input"
            placeholder="Enter your C.H. Robinson T-Number"
          />
          <div
            style={{
              fontSize: "0.8rem",
              color: "var(--text-muted)",
              marginTop: "4px",
              display: "flex",
              alignItems: "center",
              gap: "4px",
              marginLeft: "10px",
              fontWeight: "500",
            }}
          >
            Need help getting a CH Robinson T-Number?
            <button
              type="button"
              onClick={() => setIsCHRobinsonHelpModalOpen(true)}
              style={{
                background: "none",
                border: "none",
                color: "var(--primary)",
                textDecoration: "underline",
                cursor: "pointer",
                padding: "0",
                font: "inherit",
                fontSize: "0.8rem",
                transition: "none",
                boxShadow: "none",
              }}
            >
              [Learn how]
            </button>
          </div>
        </div>
      }
    </div>
  );
}
